import React from "react";
import { Card, CardBody, CardTitle, CardSubtitle, Col, Row } from "reactstrap";

import Chart from "react-apexcharts";

const VehicleColorrView = () => {
  const optionsrevenue = {
    grid: {
      show: true,
      strokeDashArray: 2,
      borderColor: "rgba(0,0,0,.3)",
      padding: {
        left: 0,
        right: 0,
        bottom: 0,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "40%",
        endingShape: "flat",
      },
    },
    colors: ["#555b6e", "#4fc3f7"],
    fill: {
      type: "solid",
      opacity: 1,
    },
    chart: {
      toolbar: {
        show: false,
      },
      sparkline: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    markers: {
      size: 0,
    },
    legend: {
      show: false,
    },
    xaxis: {
      type: "category",
      categories: ["Jun", "Jul", "Aug", "Sep", "Oct", "Nov"],
      labels: {
        style: {
          cssClass: "grey--text lighten-2--text fill-color",
        },
      },
    },
    yaxis: {
      show: true,
      labels: {
        style: {
          cssClass: "grey--text lighten-2--text fill-color",
        },
      },
    },
     stroke: {
      show: true,
      width: 5,
      colors: ['transparent']
    },
    tooltip: {
      theme: "dark",
    },
  };
  const seriesrevenue = [
    {
      name: "Black",
      data: [9, 5, 3, 7, 5, 10],
    },
    {
      name: "Blue",
      data: [6, 3, 9, 5, 4, 6],
    },
  ];
  return (
    /*--------------------------------------------------------------------------------*/
    /* Used In Dashboard-3                                                            */
    /*--------------------------------------------------------------------------------*/
    <Card
      className="w-100"
      style={{
        borderBottomLeftRadius: '15px',
        borderBottomRightRadius: '4px',
        borderTopLeftRadius: '4px',
        borderTopRightRadius: '4px',
        boxShadow: '0 5px 6px #000000',
      }}
    >
      <CardBody>
        <Row>
          <Col xs="12">
            <div className="d-flex flex-wrap">
              <div>
                <CardTitle>Vehicle Color</CardTitle>
                <CardSubtitle>Last six months</CardSubtitle>
              </div>
            </div>
          </Col>
          <Col xs="12">
            <Chart
              options={optionsrevenue}
              series={seriesrevenue}
              type="bar"
              height="290px"
            />
          </Col>
        </Row>
        <div className="d-flex no-block align-items-center justify-content-center">
          <div>
            <h6 className="text-vehicleblack">
              <i className="fa fa-circle font-10 mr-2" />
              Black
            </h6>
          </div>
          <div className="ml-3">
            <h6 className="text-vehicleblue">
              <i className="fa fa-circle font-10 mr-2" />
              Blue
            </h6>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default VehicleColorrView;
